import React from "react";
import styled from "styled-components";
import { ExternalLink } from "components/ExternalLink";
import {
  CodeBlockWrapper,
  CopyableCodeLine,
} from "onboarding/components/NumberedStep";
import { KB_URL_BASE } from "onboarding/constants";
import { track } from "utils/track";

const PACKAGE_URL = "https://github.com/appoptics/appoptics-apm-go";
const KNOWLEDGEBASE_URL = `${KB_URL_BASE}/apm_tracing/go/install/`;

const ListItem = styled.div`
  margin-bottom: ${p => p.theme.margin};

  &::before {
    content: "\\2022\\00a0\\00a0";
  }

  ${CodeBlockWrapper} {
    margin-top: ${p => p.theme.margin};
  }
`;

const goInstructions = props => {
  const { agentRecorderToken, serviceName } = props;
  return [
    {
      precedingContent: (
        <div>
          The Go agent is provided as a package available at{" "}
          <ExternalLink href={PACKAGE_URL}>{PACKAGE_URL}</ExternalLink>. See the
          quick instructions below, or{" "}
          <ExternalLink href={KNOWLEDGEBASE_URL}>
            check out our documentation
          </ExternalLink>{" "}
          for more details.
        </div>
      ),
      title: "Install the following:",
      content: (
        <div>
          <ListItem>{"Go >= 1.7"}</ListItem>
          <ListItem onClick={_ => track("Copied the Go APM package name")}>
            The AppOptics agent package:{" "}
            <CopyableCodeLine>
              {"go get github.com/appoptics/appoptics-apm-go/v1/ao"}
            </CopyableCodeLine>
          </ListItem>
        </div>
      ),
    },
    {
      title:
        "The service key is provided via an environment variable. Make sure this is available in the environment where your application is running:",
      content: (
        <div onClick={_ => track("Copied the Go APM service key")}>
          <CopyableCodeLine shell>
            export APPOPTICS_SERVICE_KEY={agentRecorderToken}:{serviceName}
          </CopyableCodeLine>
          <p>
            <ExternalLink href={KNOWLEDGEBASE_URL}>
              Check out the SDK docs
            </ExternalLink>{" "}
            on how to instrument your application.
          </p>
        </div>
      ),
    },
  ];
};

export default goInstructions;
